import _ from 'underscore';

export default class UserManageCities {
  constructor($scope, GeoService) {
    $scope.$watch('country_id', function() {
      $scope.edit_city = '';
      if ($scope.country_id) {
        GeoService.get_cities($scope.country_id).then(function(data) {
          $scope.cities = data.cities;
          if (!_.findWhere(data.cities, {id: $scope.city}))
            $scope.city = null;
        });
      }
    });

    $scope.$watch('city', function() {
      $scope.edit_city = $scope.city ? $scope.city.title : '';
    });

    $scope.update_city = function() {
      $scope.updating = true;
      $scope.update_error = '';
      var city = {
        id: $scope.city.id,
        title: $scope.edit_city
      };
      GeoService.save_city(city).then(function(data) {
        if (data.success) {
          $scope.city.title = city.title;
        } else {
          $scope.update_error = data.message;
        }
        $scope.updating = false;
      });
    };

    $scope.add_city = function() {
      $scope.adding = true;
      $scope.add_error = '';
      var city = {
        country_id: $scope.country_id,
        title: $scope.new_city
      };
      GeoService.save_city(city).then(function(data) {
        if (data.success) {
          $scope.add_error = 'City added!';
          GeoService.get_cities($scope.country_id).then(function(data) {
            $scope.cities = data.cities;
            if (!_.findWhere(data.cities, {id: $scope.city}))
              $scope.city = null;
          });
        } else {
          $scope.add_error = data.message;
        }
        $scope.adding = false;
      });
    };

    $scope.get_country_label = function(country) {
      return country.titleEN + ' (' + country.id + ')';
    };

    $scope.get_city_label = function(city) {
      return city.title + ' (' + city.id + ')';
    };

    $scope.init = function() {
      $scope.countries = window.countries;
    };

    $scope.init();
  }
}

UserManageCities.$inject = ['$scope', 'GeoService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/user-manage-cities.ctrl.js